export default {
    // REACT_APP_* variables are set in .env files and are accessible via process.env.
    // npm build runs production build, which uses .env.production
    name: process.env.REACT_APP_NAME,
    org: process.env.REACT_APP_ORG,
}